module.exports = __webpack_public_path__ + "13_hair_silver.39069677.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/13_hair_silver.png
// module id = kdFZ
// module chunks = 0